const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "icon-slack",
    x: 0,
    y: 0,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-slack1",
    serifid: "icon-slack"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.781,14.374c0,1.04 -0.85,1.891 -1.891,1.891c-1.041,-0 -1.891,-0.851 -1.891,-1.891c0,-1.041 0.85,-1.891 1.891,-1.891l1.891,-0l0,1.891Zm0.953,-0c0,-1.041 0.851,-1.891 1.891,-1.891c1.041,-0 1.891,0.85 1.891,1.891l0,4.733c0,1.041 -0.85,1.891 -1.891,1.891c-1.04,0 -1.891,-0.85 -1.891,-1.891l0,-4.733Zm1.891,-7.559c-1.04,0 -1.891,-0.85 -1.891,-1.891c0,-1.04 0.851,-1.926 1.891,-1.926c1.041,0 1.891,0.85 1.891,1.891l0,1.891l-1.891,-0l0,0.035Zm0,0.953c1.041,0 1.891,0.851 1.891,1.891c0,1.041 -0.85,1.891 -1.891,1.891l-4.735,0c-1.041,-0.07 -1.891,-0.885 -1.891,-1.926c0,-1.041 0.85,-1.891 1.891,-1.891l4.735,0l0,0.035Zm7.559,1.891c-0,-1.04 0.85,-1.891 1.891,-1.891c1.04,0 1.89,0.851 1.89,1.891c0,1.041 -0.85,1.891 -1.89,1.891l-1.891,0l-0,-1.926l-0,0.035Zm-0.954,0c0,1.041 -0.85,1.891 -1.891,1.891c-1.04,0 -1.891,-0.85 -1.891,-1.891l0,-4.77c0,-1.041 0.851,-1.891 1.891,-1.891c1.041,0 1.891,0.85 1.891,1.891l0,4.77Zm-1.855,7.559c1.041,0 1.891,0.851 1.891,1.891c-0,1.041 -0.85,1.891 -1.891,1.891c-1.041,0 -1.891,-0.85 -1.891,-1.891l-0,-1.891l1.891,0Zm-0,-0.953c-1.041,0 -1.891,-0.85 -1.891,-1.891c-0,-1.04 0.85,-1.891 1.891,-1.891l4.733,0c1.041,0 1.891,0.851 1.891,1.891c0,1.041 -0.85,1.891 -1.891,1.891l-4.733,0Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSlack);
export default __webpack_public_path__ + "static/media/icon-slack.9415dc438f928755695a96fdd10c28c4.svg";
export { ForwardRef as ReactComponent };